/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod';
import { calendarEventSchema } from './calendar-event-schema';
import { candidateSchema } from './candidate-schema';
import { contactSchema } from './contact-schema';
import { CalendarUserType } from "../enums";

export const calendarSchema: z.AnyZodObject = z.object({
  candidate: z.lazy(() => candidateSchema).nullish(),
  candidateId: z.string().uuid().nullish(),
  contact: z.lazy(() => contactSchema).nullish(),
  contactId: z.string().uuid().nullish(),
  createdAt: z.string().datetime().nullish(),
  events: z.array(z.lazy(() => calendarEventSchema)).nullish(),
  freeTimeUpdatedAt: z.string().datetime().nullish(),
  freeTimeUpdatedUserType: z.nativeEnum(CalendarUserType).nullish(),
  id: z.string().uuid(),
  timezone: z.string().nullish(),
  updatedAt: z.string().datetime().nullish(),
});

export type Calendar = z.infer<typeof calendarSchema>;
